import { render, staticRenderFns } from "./ScreenPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=template&id=3bd6431c&scoped=true&"
import script from "./ScreenPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=script&lang=js&"
export * from "./ScreenPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=script&lang=js&"
import style0 from "./ScreenPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=style&index=0&id=3bd6431c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd6431c",
  null
  
)

export default component.exports